// Yapılacaklar Listesi tablosunun sütunları. Kimlik sütunu (Görev) ve satırdan
// değiştirilebilen Durum sabitlenir. Metinler: todo.columns.<key>.

export const TASK_COLUMNS = {
  title: { type: 'text', width: 340 },
  status: { width: 176 },
  priority: { type: 'select', width: 136 },
  assignee: { type: 'select', width: 230 },
  dueDate: { width: 150 },
  createdAt: { width: 140 },
  createdBy: { width: 180 },
};

export const COLUMN_KEYS = Object.keys(TASK_COLUMNS);
export const DEFAULT_VISIBLE_COLUMNS = {
  title: true,
  status: true,
  priority: true,
  assignee: true,
  dueDate: true,
  createdAt: true,
  createdBy: false,
};
export const MIN_COLUMN_WIDTH = 96;
export const PINNED_COLUMNS = ['title', 'status'];
export const FILTER_KEYS = COLUMN_KEYS.filter((key) => TASK_COLUMNS[key].type);

/** Stored values (Firestore) in workflow / importance order. */
export const STATUSES = ['pending', 'in-progress', 'completed', 'cancelled'];
export const PRIORITIES = ['high', 'medium', 'low'];
export const STATUS_RANK = { pending: 1, 'in-progress': 2, completed: 3, cancelled: 4 };
export const PRIORITY_RANK = { low: 1, medium: 2, high: 3 };
export const ALL_STATUSES = 'all';

export const SORT_KEYS = ['createdAt', 'dueDate', 'priority', 'status', 'title'];

// Her süzgeç seçildiği anda uygulanır
export const getFilterState = (key, value) => (value === undefined || value === null || String(value) === '' ? 'off' : 'applied');
